import React from 'react'
import PersonalLoansForm from './Components/PersonalLoansForm'

const PersonalLoans = () => {
    return (
        <div>
            {/* x---------------------------------x Personal Loans Form Section x---------------------------------x */}
            <div className="row g-3">
                <div className="col-sm-12">
                    <div className="card  h-100">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold ">Apply for a peasnal loan</h3>
                        </div>
                        <div className="card-body rounded px-4">
                            {/* x---------------------------------x Personal Loans Form x---------------------------------x */}
                            <PersonalLoansForm />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default PersonalLoans